import React from 'react';
// import compose from 'redux';
import IdleTimer from "react-idle-timer";
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
//icons
// import tresub from "../../components/Icons/trezub.svg";
// core components
import Header from 'components/Header/Header.jsx';
import Footer from 'components/Footer/Footer.jsx';
import HeaderLinks from 'components/Header/HeaderLinks.jsx';
import Parallax from 'components/Parallax/Parallax.jsx';


import profilePageStyle from 'assets/jss/material-kit-react/views/profilePage.jsx';
import './ProfilePage.css';

//redux
import { connect } from 'react-redux';
import {
  initAppID,
  getApplicationList,
  // getApplication
} from '../../redux/actions/applicationAction';
import { apllicantData } from '../../redux/actions/applicantAction'

// import { isEmpty } from "../../validation/is-empty";
// import rules from "../../validation/rules";
import { createLoadingSelector } from 'redux/reducers/selectors';
// import EndUser from "utils/eusign";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import routes from './navigation/nav';
import { Switch, Route, NavLink as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Backdrop from '@material-ui/core/Backdrop';
import Trezub from '../../assets/react-svg/Trezub';
import { compose } from 'redux';

const MySwal = withReactContent(Swal);
const swalWithBootstrapButtons = MySwal.mixin({
  confirmButtonColor: '#2D5CA6',
  cancelButtonColor: '#FF0000',
  customClass: {
    confirmButton: 'br0 ',
    cancelButton: 'br0 mr-3'
  },
  buttonsStyling: true
});

// const deepCheckEmptyObject = obj => {
//   return Object.keys(obj).some(x => {
//     //console.log(x === 'i_postindex')
//     if (
//       x === "i_postindex" ||
//       x === "c_flat" ||
//       x === "c_building" ||
//       x === "c_housing"
//     ) {
//       return;
//     }
//     if (obj[x] instanceof Object) {
//       return deepCheckEmptyObject(obj[x]);
//     } else {
//       return obj[x] === "" || obj[x] === null;
//     }
//   });
// };

// function clean(obj) {
//   Object.keys(obj).forEach(key => {
//     if (obj[key] && typeof obj[key] === "object") clean(obj[key]);
//     else if (obj[key] == null || obj[key] == "") delete obj[key];
//   });
//   return obj;
// }

const styles = theme => ({
  ...profilePageStyle,
  loadingCircular: {
    color: '#2D5CA6',
    animationDuration: '550ms',
    position: 'absolute',
    //top: "50%",
    //left: '50%',
    //transform: 'translate(-50%, -50%)',
    zIndex: '99999'
  },
  links: {
    position: 'absolute',
    zIndex: 2,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    textAlign: 'center',
    color: '#ffffff'
    // marginBottom: '-30px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
});

// const reformatDateString = s => {
//   if (s.length === 0) {
//     return;
//   }
//   var b = s.split(/\D/);
//   return b.reverse().join("-");
// };

const LinkBehavior = React.forwardRef((props, ref) => (
  <Link
    ref={ref}
    component={RouterLink}
    // variant="body2"
    // onClick={(e) => e.preventDefault()}
    // activeStyle={{
    //   fontWeight: 'bold',
    //   color: 'red'
    // }}
    // to="/profile-page"
    {...props}
  />
));

class ProfilePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.state = {
      timeout: 3000,
      remaining: null,
      isIdle: false,
      lastActive: null,
      elapsed: null
    };
    this.reset = this._reset.bind(this);
    this.pause = this._pause.bind(this);
    this.resume = this._resume.bind(this);
    this.changeTimeout = this._changeTimeout.bind(this);
  }

  onAction = e => {
    // console.log("user did something", e);
  };

  onActive = e => {
    this.setState({ isIdle: false });
    //store.dispatch(isIdleAction(false))
    // console.log("user is active", e);
    // console.log("time remaining", this.idleTimer.getRemainingTime());
  };

  onIdle = e => {
    this.setState({ isIdle: true });
    // store.dispatch(isIdleAction(true));
    // console.log('user is idle', e)
    // console.log('last active from', this.idleTimer.getLastActiveTime())
    // console.log('isIdle', this.idleTimer.isIdle())
    MySwal.fire({
      title: "Час сесії закінчився",
      //text: "Your session has expired. Would you like to be redirected to the login page?",
      //type: "warning",
      //showCancelButton: true,
      confirmButtonColor: "#2D5CA6",
      confirmButtonText: "Ok",
      closeOnConfirm: false
    }).then(result => {
      //store.dispatch(isIdleAction(false))
      this.props.history.push("/login");
    });
  };
  _changeTimeout() {
    this.setState({
      timeout: this.refs.timeoutInput.state.value()
    });
  }

  _reset() {
    this.idleTimer.reset();
  }

  _pause() {
    this.idleTimer.pause();
  }

  _resume() {
    this.idleTimer.resume();
  }

  swalHandler = () => {};

  stopIDle = () => {
    this.setState({ isIdle: false });
    // store.dispatch(isIdleAction(false));
  };
  // componentDidUpdate(prevProps) {
  //   if (this.props.application.id !== prevProps.application.id) {
  //     this.props.apllicantData(this.props.application.id);
  //   }
  // }

  componentDidMount() {
   
    if (!this.getRoute()) {      
      this.props.apllicantData(this.props.application.id);
    } else {
      this.props.getApplicationList(this.props.rnokpp);
    }
  }

  getRoute = () => {
    return this.props.location.pathname === "/profile-page";
  }

  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          brand="EGAP"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 70,
            color: 'white'
          }}
          {...rest}
        />
        <Parallax small filter image={require('assets/img/profile-bg.jpg')}>
          <div className={classes.links}>
            <Trezub style={{ width: '45px', height: 'auto' }} />
            <h4 className="mt-2">Міністерство соціальної політики України</h4>
          </div>
        </Parallax>
        <div className={classNames(classes.main)}>
        <IdleTimer
              ref={ref => {
                this.idleTimer = ref;
              }}
              onActive={this.onActive}
              onIdle={this.onIdle}
              stopOnIdle={true}
              timeout={3000 * 60 * 10}
              // timeout={5000}
              startOnLoad
            />
          <Backdrop
            className={classes.backdrop}
            open={
              this.props.loading.SAVE_FILE ||
              this.props.loading.DEL_FILE ||
              this.props.loading.SAVE_PASSPORT ||
              this.props.loading.BANK ||
              this.props.loading.SAVE_ADDRESS ||
              this.props.loading.SAVE_APP ||
              this.props.loading.GET_CHILD ||
              this.props.loading.SAVE_CHILD ||
              this.props.loading.DEL_CHILD ||
              this.props.loading.APPLICANT_DATA ||
              this.props.loading.STOP ||
              false
            }
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid container justify="flex-start">
            <div className="container">
              <Grid item xs={12}>
                <Switch>
                  {routes.map((page, key) => {
                    return (
                      <Route
                        exact
                        path={page.path}
                        component={page.component}
                        key={key}
                      />
                    );
                  })}
                </Switch>
              </Grid>
            </div>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

// const loadingSelector = createLoadingSelector(['SET_DISTRICT']);
const loadingSelector = createLoadingSelector([
  'SAVE_FILE',
  'DEL_FILE',
  'SAVE_APP',
  'SAVE_ADDRESS',
  'BANK',
  'SAVE_CHILD',
  'GET_CHILD',
  'SET_DISTRICT',
  'SAVE_PASSPORT',
  'DEL_CHILD',
  'APPLICANT_DATA',
  'STOP'
]);

const mapStateToProps = state => {
  return {
    isFatching: loadingSelector(state),
    loading: state.isFatching,
    rnokpp: state.auth.user.rnokpp,
    application: state.application
  };
};

const composedComponent = compose(
  connect(mapStateToProps, {
    initAppID,
    getApplicationList,
    apllicantData
  }),
  withStyles(styles)
);

export default composedComponent(ProfilePage);
